// extracted by css-extract-rspack-plugin
export default {"warning":"ViewOptionsButton-module__warning__cukrnjA"};